export default __webpack_public_path__ + "static/media/hht1_storybook_03.46a5e7f3.png";